import { render } from "./AddUserModal.vue?vue&type=template&id=b918dfda&ts=true"
import script from "./AddUserModal.vue?vue&type=script&lang=ts"
export * from "./AddUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__